import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { generateScenarioFileUrl } from '@/utils/generateScenarioFileUrl';
import { useEffect, useMemo } from 'react';

export const COURSE_LESSON_SCENARIO_STORY_PRELOAD_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryPreload on CourseLessonScenarioStory {
    background
    content {
      ...on ScenarioContentNormal {
        character
      }
      ...on ScenarioContentDocument {
        document
        character
      }
      ...on ScenarioContentChoice {
        character
      }
      ...on ScenarioContentQuiz {
        character
      }
    }
  }
`);

export const useImagePreloader = (
  storyData: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_PRELOAD_FRAGMENT
  >[],
) => {
  // 背景とキャラクタと資料の画像パスを抽出
  const imagePaths = useMemo(() => {
    const paths = new Set<string>();
    for (const story of storyData) {
      const fragmentedStory = useFragment(
        COURSE_LESSON_SCENARIO_STORY_PRELOAD_FRAGMENT,
        story,
      );
      if (fragmentedStory.background) {
        paths.add(
          generateScenarioFileUrl(fragmentedStory.background, 'background'),
        );
      }

      if (
        fragmentedStory.content.__typename === 'ScenarioContentNormal' ||
        fragmentedStory.content.__typename === 'ScenarioContentDocument' ||
        fragmentedStory.content.__typename === 'ScenarioContentQuiz' ||
        fragmentedStory.content.__typename === 'ScenarioContentChoice'
      ) {
        if (fragmentedStory.content.character) {
          paths.add(
            generateScenarioFileUrl(
              fragmentedStory.content.character,
              'character',
            ),
          );
        }
      }

      if (fragmentedStory.content.__typename === 'ScenarioContentDocument') {
        paths.add(
          generateScenarioFileUrl(fragmentedStory.content.document, 'document'),
        );
      }
    }
    return Array.from(paths);
  }, [storyData]);

  // 画像をプリロード
  useEffect(() => {
    for (const path of imagePaths) {
      const img = new Image();
      img.src = path;
    }
  }, [imagePaths]);
};
